module.exports = __webpack_public_path__ + "img/banner2.77c8828f.jpg";